import { node, oneOfType, shape, string } from 'prop-types'
import { forwardRef } from 'react'
import Typography from '../../atoms/typography'
import Accordion from './accordion'
import { Title } from './accordion-text.styled'

const AccordionText = forwardRef(function AccordionText(
	{ title, titleProps, description, descriptionProps, ...props },
	ref
) {
	return (
		<Accordion
			{...props}
			title={
				<Title variant="h6" {...titleProps}>
					{title}
				</Title>
			}
			ref={ref}
		>
			<Typography variant="body1" {...descriptionProps}>
				{description}
			</Typography>
		</Accordion>
	)
})

AccordionText.defaultProps = {
	...Accordion.defaultProps,
}

AccordionText.propTypes = {
	...Accordion.propTypes,
	title: oneOfType([string, node]),
	description: oneOfType([string, node]),
	titleProps: shape(Typography.propTypes),
	descriptionProps: shape(Typography.propTypes),
}

export default AccordionText
